import * as React from 'react';

function SvgCartIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      stroke="#363D43"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M13.454 5.147H2.546C1.692 5.147 1 5.877 1 6.78v6.587C1 14.27 1.692 15 2.546 15h10.908c.854 0 1.546-.731 1.546-1.633V6.78c0-.902-.692-1.633-1.546-1.633ZM4.107 5.082C4.107 2.829 5.84 1 7.973 1c2.133 0 3.865 1.829 3.865 4.082"
    />
  </svg>)
}
export default SvgCartIcon;
